import { render, staticRenderFns } from "./IconCase.vue?vue&type=template&id=f5724c26&scoped=true&"
import script from "./IconCase.vue?vue&type=script&lang=js&"
export * from "./IconCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5724c26",
  null
  
)

export default component.exports